// src/mixins/confirmLeave.js
export default {
  beforeRouteLeave(to, from, next) {
    // Show a confirmation dialog when navigating away from the page
    const answer = window.confirm("Are you sure you want to leave this page? Unsaved data may be lost.");
    if (answer) next();
    else next(false);
  },

  mounted() {
    // Handle page refresh or closing the tab
    window.addEventListener("beforeunload", this.beforeUnload);
  },

  beforeUnmount() {
    // Cleanup event listener to avoid memory leaks
    window.removeEventListener("beforeunload", this.beforeUnload);
  },

  methods: {
    beforeUnload(event) {
      event.preventDefault();
      event.returnValue = ""; // Required for most browsers to show confirmation
    },
  },
};
